
/**
 * CONTINAS CONTANTS URL odd_formats
 */

const odd_formats = [
  {
    'odd_formats_id': 1,
    'name': 'eu'
  }, {
    'odd_formats_id': 2,
    'name': 'uk'
  }, {
    'odd_formats_id': 3,
    'name': 'us'
  }
];

export default odd_formats;